// extracted by mini-css-extract-plugin
export default {"editorContainer":"Static_editorContainer__Fn1tY","staticContainer":"Static_staticContainer__ZLCCu","inlineLoader":"Static_inlineLoader__v+l4h"};